/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiWebInstytucjeNipPlikiPlzIdGet$Xml$Params {
  nip: string;
  plzId: number;
}

export function apiWebInstytucjeNipPlikiPlzIdGet$Xml(http: HttpClient, rootUrl: string, params: ApiWebInstytucjeNipPlikiPlzIdGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<{
}>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeNipPlikiPlzIdGet$Xml.PATH, 'get');
  if (params) {
    rb.path('nip', params.nip, {});
    rb.path('plzId', params.plzId, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      }>;
    })
  );
}

apiWebInstytucjeNipPlikiPlzIdGet$Xml.PATH = '/api/web/instytucje/{nip}/pliki/{plzId}';
